/* global proposalList:true */

/**
 * Object: approvalProcessDialog
 * Purpose:
 */
proposalList = function(id, cui_enabled) {
	'use strict';

	var objProposalList = list(null, cui_enabled);
	var objDom = dom(cui_enabled);
	var objDialog = dialog();
  var cui_enabled = cui_enabled;

	/* To extend and modify a parent's function
	objApprovalProcessDialog.pageList = function() {

	}
	*/

	objProposalList.approvalErrorDialog = function(jobResults) {
		var proposalErrors = jobResults.status.meta.proposals || null;
		if (proposalErrors !== null ) {
			if ( proposalErrors.length > 2 ) {
				$('.approval-error-number').text(proposalErrors.length + ' proposals');
			} else {
				$('.approval-error-number').text(proposalErrors.length + ' proposal');
			}

			$('#curriculog-approve-multiple-error .proposal-list li').remove();
			_.each(proposalErrors, function(proposalError){
				$('<li />').text(proposalError.name + ' (' + proposalError.error + ')').appendTo('#curriculog-approve-multiple-error .proposal-list');
			});
			var dialog = objDialog.createDOMWarningDialog('curriculog-approve-multiple-error', function(dialog, defaults) {
					defaults.buttons = {
						'OK': function() {
							$(this).dialog('close');
							location.href = '/proposals';
						}
					};
					$(dialog).dialog(defaults);
			});
		} else {
			var errorText = 'An error was encountered when approving selected proposals.  ';
			errorText += 'The proposals may not have been approved. Please try again '
			errorText += 'or contact an administrator.';
			$('#growls').notify('create','warning-template', {
				title: 'Proposal Decision Error',
				text: errorText
			});
		}
	};

	objProposalList.requestMultipleApproval = function(selectedProposals, userID, pin){
		var method_args = {
			'userID': userID,
			'proposals': selectedProposals
		};
		if ( pin ){
			method_args['pin'] = pin;
		}
		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			mask: $('#curriculog-page'),
			data: JSON.stringify({
				functionName: 'multiple_proposal_approve_task',
				workload: {
					module_name: 'ProposalApprove',
					method_name: 'approveProposals',
					method_args: method_args
				}
			}),

			beforeSend: function () {
				window.focus();
				objDom.addCustomMask('#curriculog-page', 'Approve selected proposals', '50');
			},
			success: function (results) {
					getBackgroundJobStatus(
							results.jobHandle,
							this.mask,
							'Approve selected proposals',
							function (result) {
									location.href = '/proposals';
							},
							function (jobResults){
									objProposalList.approvalErrorDialog(jobResults);
							}
					);
			},

			error: function () {
					domObject.removeMask(this.mask);

					var errorText = 'An error was encountered when approving selected proposals.  ';
					errorText += 'The proposals have not been approved. Please try again '
					errorText += 'or contact an administrator.';
					$('#growls').notify('create','warning-template', {
						title: 'Proposal Decision Error',
						text: errorText
					});
			},
		});
	};



	objProposalList.approveMultiple = function (selectedProposals, userID) {
		if (!selectedProposals || selectedProposals.length === 0){
			var noProposalsDialog = new Curriculog.WarningDialog({
				title: "No Proposals Selected",
				message: "Please select at least one proposal to approve.",
				buttons: {
					'OK': function(){
						this.close();
					}
				}
			});
			return;
		}

		var confirmDialogButtons = {};
		var readyProposals = _.where(selectedProposals, {signature: false}); // proposals that can be approved.
		var waitingSigProposals = _.where(selectedProposals, {signature: true}); // proposals waiting to be signed with PIN

		$('#curriculog-approve-multiple .proposal-list li').remove();

		if ( waitingSigProposals.length === 0 ){
			$('.without-signature').show();
			$('.with-signature').hide();

			var numProposals = ( selectedProposals.length > 1 ) ? selectedProposals.length + ' proposals' : selectedProposals.length + ' proposal';
			$('.approval-ready-number').text(numProposals);

			_.each(selectedProposals, function(item) {
				$('<li />').text(item.name).appendTo('#curriculog-approve-multiple ul.without-signature');
			});

			confirmDialogButtons = {
				'Approve All': function() {
						$(this).dialog('close');
						var selectedProposalIds = _.map(selectedProposals, function(item){ return _.pick(item, 'proposalID', 'currentStepID');});
						objProposalList.requestMultipleApproval(selectedProposalIds, userID);
					},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
		} else {
			$('.without-signature').hide();
			$('.with-signature').show();

			if ( readyProposals.length === 0 ) {
				$('.approval-ready').hide();
			} else {
				$('.approval-ready').show();
				var numReadyProposals = ( readyProposals.length > 1 ) ? readyProposals.length + ' proposals' : readyProposals.length + ' proposal';
				$('.approval-ready-number').text(numReadyProposals);

				_.each(readyProposals, function(item){
					$('<li />').text(item.name).appendTo('#curriculog-approve-multiple ul.approval-ready');
				});
			}

			var numWaitingSigProposals = ( waitingSigProposals.length > 1 ) ? waitingSigProposals.length + ' proposals require' : waitingSigProposals.length + ' proposal requires';
			$('#signature-required-number').text(numWaitingSigProposals);

			_.each(waitingSigProposals, function(item){
				$('<li />').text(item.name).appendTo('#curriculog-approve-multiple .signature-required');
			});

			confirmDialogButtons = {
				'Approve All': function(){
					var postParam = {
						id :  userID,
						pin : $('#approve-signature').val() ? $('#approve-signature').val().trim() : ''
					};

					$.ajax({
						url: '/user/signature.json',
						type: 'get',
						data: postParam,
						success: function(result){
							if (parseInt(result.success, 10) === 1) {
								$('#curriculog-approve-multiple').dialog('close');
								var selectedProposalIds = _.map(selectedProposals, function(item){ return _.pick(item, 'proposalID', 'currentStepID');});
								objProposalList.requestMultipleApproval(selectedProposalIds, userID, postParam.pin);
							} else {
                if (!cui_enabled) {
                  $('#approve-signature').addClass('has-error');
                }
								$('#signature-error').slideDown('medium');
							}
						}
					});

				},
				'Approve Non-PIN Only': function() {
					$(this).dialog('close');
					var selectedProposalIds = _.map(readyProposals, function(item){ return _.pick(item, 'proposalID', 'currentStepID');});
					objProposalList.requestMultipleApproval(selectedProposalIds, userID);
				},
				'Cancel': function() {
					$('#approve-signature').val('');
          if (!cui_enabled) {
            $('#approve-sigature').removeClass('has-error');
          }
					$('#signature-error').hide();
					$(this).dialog('close');
				}
			};

			if ( readyProposals.length === 0 ){
				delete confirmDialogButtons['Approve Non-PIN Only'];
			}

		}
		var dialog = objDialog.createDOMDialog('curriculog-approve-multiple', function(dialog, defaults) {
				defaults.buttons = confirmDialogButtons;
				$(dialog).dialog(defaults);
		});

	};


	objProposalList.getFlyout = function(id, callback) {
		$.ajax({
			url: '/proposal:' + id + '/ajax/flyout',
			type: 'GET',
			data: {id: id, display:'flyout'},
			beforeSend: function() {
        if (cui_enabled) {
          var summaryColumn = $('#curriculog-summary-column');
          var leftPosition = summaryColumn.offset().left + summaryColumn.width()/2;
  				objDom.addCustomMask('#curriculog-summary-column', 'Loading Proposal Summary', null, leftPosition);
        } else {
          var centerHeight = $(window).scrollTop() + ($(window).height()/2);
  				objDom.addCustomMask('#curriculog-summary-column', 'Loading Proposal Summary', centerHeight);
        }

			},
			success: function(result) {
				$(result).find('#summary-' + id).addClass('active');
				var summary = $(result).find('#summary-' + id);
				$('#summary-' + id).contents().remove();
				$('#summary-' + id).replaceWith(summary);
				$('#summary-' + id).addClass('active');

				callback && callback(id);
				Curriculog.Actions.log('flyout-loaded');
			}
		});
	};

	objProposalList.getAdminFlyout = function(id, tab, callback) {
		var flyout = (tab === 'needsattention' || tab === 'proposals') ? 'adminFlyout': 'flyout';
		$.ajax({
			url: '/proposal:' + id + '/ajax/' + flyout,
			type: 'GET',
			data: {id: id, display:flyout},
			beforeSend: function() {
        if (cui_enabled) {
          var summaryColumn = $('#curriculog-summary-column');
          var leftPosition = summaryColumn.offset().left + summaryColumn.width()/2;
  				objDom.addCustomMask('#curriculog-summary-column', 'Loading Proposal Summary', null, leftPosition);
        } else {
          var centerHeight = $(window).scrollTop() + ($(window).height()/2);
  				objDom.addCustomMask('#curriculog-summary-column', 'Loading Proposal Summary', centerHeight);
        }
			},
			complete: function () {
				objDom.removeMask('#curriculog-summary-column');
			},
			success: function(result) {
				var summary = $(result).find('#summary-' + id);
				$('#summary-' + id).contents().remove();
				$('#summary-' + id).replaceWith(summary);
				$('#summary-' + id).addClass('active');

				callback && callback(id);
				Curriculog.Actions.log('flyout-loaded');
			}
		});
	};

	objProposalList.updateStuck = function(proposalId, decision, obj, data) {
		var currentStepID = $(obj).attr('class').match(/step-(\d*)/)[1],
		    comment = '',
		    superAdmin = false;

		if (data) {
			comment = data.comment || comment;
			superAdmin = data.superAdmin || superAdmin;
		}

		// userId will be populated by PHP controller
		var stuckData = {
			proposalID: proposalId,
			userID: 0,
			decision: decision,
			currentStepID: currentStepID,
			comment: comment,
			superAdmin: superAdmin,
		};

		//Change the ajax call to use the preferred deferred object instead of the old syntax
		$.ajax({
			url: '/proposal/updateStuck.json',
			type: 'PUT',
			data: stuckData,
			beforeSend: function () {
				// Only add mask and disable buttons if the ajax call has been initiated
				objDom.addMask('#summary-' + proposalId);
				$(obj).attr('disabled', true).siblings().attr('disabled', true);
			}
		}).done(function () {
			Backbone.trigger('filter:submit');
		}).fail(function () {
			// If the call fails, show a growl to the user so they are aware there is an error
			$('#growls').notify('create','warning-template', {
				title: 'Proposal Decision Error',
				text: 'Could not complete the forced decision on the proposal, please try again later.'
			});
		}).always(function () {
			// Remove the mask and re-enable the buttons regardless if the call was successful or not
			objDom.removeMask('#summary-' + proposalId);
			$(obj).attr('disabled', false).siblings().attr('disabled', false);
		});
	};

	// delete
	objProposalList.deleteProposal = function(id, deleteType) {
		/*
			Business Logic
			1. Proposal is primary crosslisting and unlaunched:
			    Originator only can hard delete (family will be deleted)
			2. Proposal is crosslisting and unlaunched:
				Originator only can hard delete
			3. Proposal is primary crosslisting and launched:
				Admin only can soft delete (family will be deleted)
			4. Proposal is crosslisting and launched:
				Admin only can soft delete
		*/

		var crosslisted = $('#detail-' + id + ' .list-name').data().isCrosslisted;

		// if is not a parent crosslisting we don't need the family
		if (crosslisted){
			objProposalList.getcrosslistedFamily(id).then(function(response) {
				objProposalList.confirmDeleteProposal(id, deleteType, response);
			});
		}
		else {
			objProposalList.confirmDeleteProposal(id, deleteType);
		}

		objDom.addLoadingMask('#curriculog-list-column-results');


	};

	objProposalList.confirmDeleteProposal = function(id, deleteType, crosslistingData) {

		var isPrimary = false;

		if (crosslistingData){
			isPrimary = (crosslistingData.parent_id === parseInt(id)) ? true : false;
		}

		var msg = '';
		var buttonName = '';

		if (isPrimary) {
			var crosslistingHTML = objProposalList.formatCrosslistings(crosslistingData);
			msg = 'This proposal is the primary proposal in a family of crosslisted proposals. '+
				'Deleting this proposal will permanently remove it from Curriculog along with all the other proposals who are ' +
				'crosslisted to this proposal. Are you sure you want to delete this proposal along with its crosslistings?' +
				'<br><br> ' + $(crosslistingHTML)[0].outerHTML;
			buttonName = 'Delete this proposal and its crosslistings';

		} else {
			msg = 'Deleting this Proposal will permanently remove it from Curriculog. Are you sure you want to delete this Proposal?';
			buttonName = 'Delete proposal';
		}


		new ProposalsDialog({
			proposalId: id,
			message: msg,
			buttons: function() {
				var buttons = {};
				buttons[buttonName] = deleteType + 'DeleteProposal';
				buttons['Cancel']= 'cancelRequest';
				return buttons;
			}
		});

	};


	objProposalList.softDeleteProposal = function(proposalId) {

		var stuckData = {
			proposalID: proposalId,
			userID: 0,
			decision: 'delete',
			currentStepID: $('#detail-' + proposalId).attr('class').match(/current-step-id-(\d*)/)[1],
		};

		return $.ajax({
			url: '/proposal/softDeleteProposal.json',
			type: 'PUT',
			data: stuckData,
			beforeSend: function() {
				objDom.addMask('#summary-' + proposalId);
			},
			success: function(data) {
				objDom.removeMask('#summary-' + proposalId);
				objDom.removeMask('#curriculog-list-column-results');
				Backbone.trigger('listItem:checkPage');

			}
		});
	};

	objProposalList.hardDeleteProposal = function(id) {

		return $.ajax({
			url: '/proposal:' + id + '.json',
			type: 'DELETE',
			async:false,
			success: function(result) {
				objDom.removeMask('#curriculog-list-column-results');
				Backbone.trigger('listItem:checkPage');
				Backbone.trigger('Form:refreshCrosslistingsTab');
			}
		});
	};


	// crosslistings functions

	objProposalList.getcrosslistedFamily = function(proposalId){
		return $.ajax({
			url: '/rpc/proposal/crosslistedFamily.json',
			type: 'GET',
			data: {proposalId: proposalId}
		});
	};


	objProposalList.formatCrosslistings = function(crosslistedFamily){

		var family = $('<ul/>').attr('id', 'dialog-crosslistings');
		$.each(crosslistedFamily.crosslistings, function(index, crosslisting) {
			$('<li/>')
				.attr('style', 'text-align: center')
				.text(crosslisting.name).appendTo(family);
		});

		var html = $('<ul/>')
			.attr('id', 'dialog-crosslisting-family')
			.append('<li/>').text(crosslistedFamily.parent_name + ' (primary)')
			.append(family);

		return html;
	};


	objProposalList.cancelRequests = function(proposalId){
		objDom.removeMask('#summary-' + proposalId);
		objDom.removeMask('#curriculog-list-column-results');
		Backbone.trigger('listItem:checkPage');
	};

	// general dialog

	var ProposalsDialog = Curriculog.WarningDialog.extend({
		beforeClose: function(event) {
	        if (event.keyCode === 27) {
	           objProposalList.cancelRequests(this.id);
	        }
	    },
		buttons: {
			'Cancel': 'cancel'
		},
		cancelRequest: function () {
			objProposalList.cancelRequests(this.id);
			this.close();
		},
		cancel: function () {
			this.close();
		},
		softDeleteProposal: function () {
			objProposalList.softDeleteProposal(this.proposalId);
			this.close();
		},
		hardDeleteProposal: function () {
			objProposalList.hardDeleteProposal(this.proposalId);
			this.close();
		}
	});


	/*
	 * Function: watch
	 * Purpose:
	 */
	objProposalList.watch = function(proposalId) {
		$.ajax({
			url: '/proposal:' + proposalId + '/watch.json',
			type: 'put',
			async:false,
			success: function(result) {
				if (parseInt(result.success, 10) === 0) {
					$('#growls').notify('create','warning-template', {
						title: 'Watch Proposal',
						text: 'Error'
					});
				} else {
					Backbone.trigger('listItem:checkPage');
					Curriculog.Actions.log('proposal-watched');
				}
			}
		});
	};


	/*
	 * Function: unwatch
	 * Purpose:
	 */
	objProposalList.unwatch = function(proposalId) {
		$.ajax({
			url: '/proposal:' + proposalId + '/unwatch.json',
			type: 'put',
			async:false,
			success: function(result) {
				if (parseInt(result.success, 10) === 0) {
					$('#growls').notify('create','warning-template', {
						title: 'Watch Proposal',
						text: 'Error'
					});
				} else {
					Backbone.trigger('listItem:checkPage');
					Curriculog.Actions.log('proposal-unwatched');
				}
			}
		});
	};

	objProposalList.updateRequest = function(obj) {
		var currentStepID = $(obj).attr('class').match(/step-(\d*)/)[1];

		var params = {
			proposalId: $(obj).closest('.summary').attr('id').substring(8),
			currentStepId: currentStepID,
			decision: $(obj).attr('class').match(/action-approve-(\w*)/)[1]
		};
		// console.log(params);
		$.ajax({
			url: '/admin/dashboard/resolveRequest.json',
			type: 'PUT',
			data: params,
			success: function(response){
				Backbone.trigger('listItem:checkPage');
			}
		});
	};

	objProposalList.rejectRequest = function(obj) {
		var currentStepID = $(obj).attr('class').match(/step-(\d*)/)[1];
		var proposalId = $(obj).closest('.summary').attr('id').substring(8);

		var params = {
			proposalId: proposalId,
			currentStepId: currentStepID,
			decision: $(obj).attr('class').match(/action-(\w*-\w*)/)[1],
			proposalStepActionID: $(obj).data('psa-id'),
		};

		$.ajax({
			url: '/admin/dashboard/resolveRequest.json',
			type: 'PUT',
			data: params,
			success: function(response){
				var requests = $('.action-requests');

				if (requests.length > 1) {
					objProposalList.getAdminFlyout(proposalId, 'needsattention', function () {
						objDom.removeMask('#curriculog-summary-column');
					});
				} else {
					Backbone.trigger('listItem:checkPage');
				}
			}
		});
	};

	objProposalList.resolveCrosslistingReview = function(id, decision) {
		var decisionText = (decision === 'launch') ? 'approved' : 'rejected';

		var proposalData = {
			userId : $('input[name="user-id"]').val(),
			userName : $('input[name="user-name"]').val(),
			currentStepId : 0,
			decision : decision
		};

		// console.log(proposalData);

		$.ajax({
			url: '/proposal:' + id + '/ajax/makeDecision.json',
			type: 'PUT',
			data: proposalData,
			beforeSend: function() {
				objDom.addLoadingMask('.summary');
			},
			success: function(success) {
				objDom.removeMask('.summary');
				var title = '';
				var text = '';

				if(decision == 'unlaunch') {
					$('#growls').notify("create","saved-template", {

						title: 'Successful Rejection',
						text: 'This proposal has returned to the originator for further work.'
					});

				} else {
					$('#growls').notify('create', 'saved-template', {
						title: 'Successful Approval',
						text: 'This proposal is now active and on its first step in the approval process.'
					});
				}

				Backbone.trigger('listItem:checkPage');

			}
		});
	};

	objProposalList.removeStatus = function(obj) {
		var decision = $(obj).attr('class').match(/action-admin-remove-(\w*)/)[1];
		var decisionParam = '';
		var currentStepID = $(obj).attr('class').match(/step-(\w*)/)[1];
		var filter;

		if (decision === 'hold') {
			decisionParam = 'remove-hold';
			filter = 'Hold';
		} else if (decision === 'suspension') {
			decisionParam = 'remove-suspend';
			filter = 'Suspend';
		}

		var paramData = {
			proposalId: $(obj).closest('.summary').attr('id').substring(8),
			currentStepId: currentStepID,
			decision: decisionParam
		};
		// console.log(paramData);
		$.ajax({
			url: '/admin/dashboard/resolveRequest.json',
			type: 'PUT',
			data: paramData,
			success: function(response){
				Backbone.trigger('listItem:checkPage');

			}
		});
	};

	return objProposalList;

};
